/* Built by Mika — bbm-theme.js */

document.addEventListener('DOMContentLoaded', function () {

  // ── Custom cursor ──────────────────────────────────────────────
  // Only on non-touch devices
  var hasHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var c1 = document.getElementById('c1');
  var c2 = document.getElementById('c2');
  if (c1 && c2 && hasHover) {
    var mx = 0, my = 0, rx = 0, ry = 0;
    var cursorVisible = false;
    // Start hidden until first mousemove
    c1.style.opacity = '0';
    c2.style.opacity = '0';
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!cursorVisible) {
        cursorVisible = true;
        c1.style.opacity = '1';
        c2.style.opacity = '1';
      }
    });
    (function animCursor() {
      c1.style.left = mx + 'px';
      c1.style.top  = my + 'px';
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      c2.style.left = rx + 'px';
      c2.style.top  = ry + 'px';
      requestAnimationFrame(animCursor);
    })();
    document.querySelectorAll('a, button, .bcard, .ccard, .csub, .bc, .yt, .sc, .mpill, .chip, .ftab').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        c1.style.width = '14px'; c1.style.height = '14px';
        c2.style.width = '46px'; c2.style.height = '46px';
      });
      el.addEventListener('mouseleave', function () {
        c1.style.width = '8px'; c1.style.height = '8px';
        c2.style.width = '30px'; c2.style.height = '30px';
      });
    });
  } else if (c1 && c2) {
    // Touch device — hide cursor elements
    c1.style.display = 'none';
    c2.style.display = 'none';
  }

  // ── Nav scroll shadow ──────────────────────────────────────────
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('up', window.scrollY > 40);
    });
  }

  // ── Scroll reveal ──────────────────────────────────────────────
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('vs');
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

  // ── Cart count badge ───────────────────────────────────────────
  var cartCount = document.querySelector('.cart-count');
  if (cartCount) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.item_count > 0) {
          cartCount.textContent = data.item_count;
          cartCount.style.display = 'flex';
        } else {
          cartCount.style.display = 'none';
        }
      });
  }

  // ── Add-to-cart (product pages) ───────────────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function () {
        window.location.href = '/cart';
      });
    });
  });

});

/* ── Inline nav search toggle ────────────────────────────────── */
(function () {
  var toggle = document.getElementById('nav-search-toggle');
  var wrap   = document.getElementById('nav-search-wrap');
  var input  = document.getElementById('nav-search-input');
  if (!toggle || !wrap || !input) return;

  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    var isOpen = wrap.classList.contains('open');
    if (isOpen) {
      // If there's text, submit the form
      if (input.value.trim()) {
        input.closest('form').submit();
      } else {
        wrap.classList.remove('open');
        input.blur();
      }
    } else {
      wrap.classList.add('open');
      setTimeout(function () { input.focus(); }, 320);
    }
  });

  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) {
      wrap.classList.remove('open');
    }
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      wrap.classList.remove('open');
      input.blur();
    }
  });
})();

/* ── Mega Menu ────────────────────────────────────────────────── */
(function () {
  var trigger  = document.getElementById('mm-trigger');
  var btn      = trigger && trigger.querySelector('.mm-btn');
  var menu     = document.getElementById('mega-menu');
  var overlay  = document.getElementById('mm-overlay');
  var hamburger = document.getElementById('mm-hamburger');
  var drawer   = document.getElementById('mm-mobile-drawer');
  var mclose   = document.getElementById('mm-mobile-close');

  if (!btn || !menu) return;

  var isOpen = false;
  var closeTimer;

  function openMenu() {
    clearTimeout(closeTimer);
    isOpen = true;
    menu.classList.add('open');
    overlay && overlay.classList.add('show');
    btn.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    isOpen = false;
    menu.classList.remove('open');
    overlay && overlay.classList.remove('show');
    btn.setAttribute('aria-expanded', 'false');
  }

  function scheduleClose() {
    closeTimer = setTimeout(closeMenu, 120);
  }

  // Hover — desktop
  trigger.addEventListener('mouseenter', openMenu);
  trigger.addEventListener('mouseleave', scheduleClose);
  menu.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
  menu.addEventListener('mouseleave', scheduleClose);

  // Click toggle — also works on touch
  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    isOpen ? closeMenu() : openMenu();
  });

  // Close on outside click
  document.addEventListener('click', function (e) {
    if (!menu.contains(e.target) && !trigger.contains(e.target)) closeMenu();
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); closeMobileDrawer(); }
  });

  // Overlay click closes both
  overlay && overlay.addEventListener('click', function () {
    closeMenu();
    closeMobileDrawer();
  });

  // ── Chassis make switcher ──────────────────────────────────────
  document.querySelectorAll('.mm-make').forEach(function (makeBtn) {
    makeBtn.addEventListener('click', function () {
      var make = this.dataset.make;

      document.querySelectorAll('.mm-make').forEach(function (b) {
        b.classList.remove('on');
      });
      this.classList.add('on');

      document.querySelectorAll('.mm-chassis-panel').forEach(function (panel) {
        panel.classList.remove('on');
      });
      var target = document.querySelector('.mm-chassis-panel[data-panel="' + make + '"]');
      if (target) target.classList.add('on');
    });
  });

  // ── Mobile hamburger ───────────────────────────────────────────
  function openMobileDrawer() {
    drawer && drawer.classList.add('open');
    overlay && overlay.classList.add('show');
    hamburger && hamburger.classList.add('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeMobileDrawer() {
    drawer && drawer.classList.remove('open');
    overlay && overlay.classList.remove('show');
    hamburger && hamburger.classList.remove('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
  }

  hamburger && hamburger.addEventListener('click', function (e) {
    e.stopPropagation();
    drawer && drawer.classList.contains('open') ? closeMobileDrawer() : openMobileDrawer();
  });

  mclose && mclose.addEventListener('click', closeMobileDrawer);

})();

/* ── Shop Bar dropdowns (Category / Brand / Chassis) ─────────── */
(function () {
  var triggers = [
    { trigger: 'nb-cat-trigger',     panel: 'nb-cat-panel'     },
    { trigger: 'nb-brand-trigger',   panel: 'nb-brand-panel'   },
    { trigger: 'nb-chassis-trigger', panel: 'nb-chassis-panel' },
  ];

  var openPanel = null;

  triggers.forEach(function (item) {
    var wrap  = document.getElementById(item.trigger);
    var panel = document.getElementById(item.panel);
    var btn   = wrap && wrap.querySelector('.nb-bar-btn');
    if (!wrap || !panel || !btn) return;

    function open() {
      // close any other open panel first
      triggers.forEach(function (other) {
        if (other.trigger !== item.trigger) {
          var op = document.getElementById(other.panel);
          var ob = document.getElementById(other.trigger) && document.getElementById(other.trigger).querySelector('.nb-bar-btn');
          if (op)  op.classList.remove('open');
          if (ob)  ob.setAttribute('aria-expanded', 'false');
        }
      });
      panel.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      openPanel = item.trigger;
    }

    function close() {
      panel.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      if (openPanel === item.trigger) openPanel = null;
    }

    // hover — desktop
    var closeTimer;
    wrap.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(); });
    wrap.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, 150); });
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, 150); });

    // click toggle
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      panel.classList.contains('open') ? close() : open();
    });
  });

  // close all on outside click or Escape
  document.addEventListener('click', function () {
    triggers.forEach(function (item) {
      var p = document.getElementById(item.panel);
      var b = document.getElementById(item.trigger) && document.getElementById(item.trigger).querySelector('.nb-bar-btn');
      if (p)  p.classList.remove('open');
      if (b)  b.setAttribute('aria-expanded', 'false');
    });
    openPanel = null;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.dispatchEvent(new MouseEvent('click'));
  });

  // ── Chassis make switcher in shop bar ──────────────────────────
  document.querySelectorAll('.nb-make').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var make = this.dataset.make;
      // update active make button
      this.closest('.nb-chassis-makes').querySelectorAll('.nb-make').forEach(function (b) {
        b.classList.remove('on');
      });
      this.classList.add('on');
      // show matching panel
      this.closest('.nb-dropdown-chassis').querySelectorAll('.nb-chassis-panel').forEach(function (p) {
        p.classList.remove('on');
      });
      var target = this.closest('.nb-dropdown-chassis').querySelector('[data-panel="' + make + '"]');
      if (target) target.classList.add('on');
    });
  });

})();
